module.exports = __webpack_public_path__ + "img/product18-dingzhihua.60765852.svg";